import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M37.841 9.716c.124 2.053.186 4.718.186 7.999 0 7.047-.285 15.523-.856 25.429a1.966 1.966 0 0 1-3.353 1.277l-8.022-8.022c-.601-.601-.843-.764-1.16-.86a1.25 1.25 0 0 0-.744 0c-.319.096-.56.259-1.161.86l-8.025 8.025a1.966 1.966 0 0 1-3.353-1.274c-.569-9.647-.853-18.093-.853-25.34 0-3.322.06-6.013.18-8.077a6.882 6.882 0 0 1 6.255-6.455C19.002 3.092 21.445 3 24.263 3c2.817 0 5.257.092 7.322.277a6.882 6.882 0 0 1 6.256 6.44Zm-14.56 11.556 7.169-7.17c.927-.927 2.317.463 1.39 1.39l-7.864 7.865c-.348.348-.927.464-1.39 0l-4.916-4.915c-.927-.927.463-2.317 1.39-1.39l4.22 4.22Z",
      clipRule: "evenodd"
    }
  )
);
var SvgBookmarkAddedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkAddedFilled_default = SvgBookmarkAddedFilled;

export { BookmarkAddedFilled_default as default };
